import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=6d752616"
import script from "../services/privacy-policy.js?vue&type=script&lang=js&external"
export * from "../services/privacy-policy.js?vue&type=script&lang=js&external"
import style0 from "../assets/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/css/privacy-policy.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports